import MarqueeStrip from "react-fast-marquee";
import { Flame } from "lucide-react";

const items = [
  "Proudly Serving East TN",
  "24/7 Emergency HVAC",
  "865-660-9589",
  "Heating",
  "Cooling",
  "Licensed & Insured",
];

export default function Marquee() {
  return (
    <div
      className="border-y border-white/10 bg-[#FF6B00] py-4 overflow-hidden"
      data-testid="marquee-strip"
    >
      <MarqueeStrip speed={40} gradient={false} pauseOnHover>
        {items.map((item) => (
          <div key={item} className="flex items-center">
            <span className="font-display font-semibold uppercase tracking-wide text-xl md:text-2xl text-[#050505] px-8">
              {item}
            </span>
            <Flame className="w-5 h-5 text-[#050505]" strokeWidth={2.5} />
          </div>
        ))}
      </MarqueeStrip>
    </div>
  );
}
